const autoNgTemplateLoaderTemplate1 = require('./registry-form-proget.html');

angular.module('shbdeployer.app').component('registryFormProget', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '=',
    formAction: '<',
    formActionLabel: '@',
    actionInProgress: '<',
  },
});
